import { postReq } from '../utils/request'

export default {
	undelete: (data: object) => postReq('/api/admin/admin/undelete', {}, data)
}
